import { getGeschaeftsart, GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { App, Immobilie } from '@ps20-frontend/frontend-models';
import { AnyAction } from 'redux';
import { Vertragsgrund } from '@ps20/bff-models';
import { IAppState } from '../appState';
import { VwgActions } from '../vwgActions';

export interface Vorbelegungen {
  immobilieVorbelegt: boolean;
  adresseImmobilieVorbelegt: boolean;
  versicherungsnehmerVorbelegt: boolean;
  oeltankVorbelegt: boolean;
  activateElementar?: boolean;
}

export const vorbelegungenReducer = function (
  sectionState: Vorbelegungen = null,
  action: AnyAction,
  appState: IAppState,
): Vorbelegungen {
  switch (action.type) {
    case GlobalActions.IMMOBILIE_UEBERNEHMEN: {
      if (action.payload.appId !== App.VWG || action.payload.angebotsId !== appState.angebotsId) {
        return sectionState;
      }

      const immobilie: Immobilie = action.payload.immobilie;
      return {
        immobilieVorbelegt: true,
        adresseImmobilieVorbelegt: true,
        versicherungsnehmerVorbelegt: sectionState.versicherungsnehmerVorbelegt,
        oeltankVorbelegt: immobilie.oeltank,
        activateElementar:
          getGeschaeftsart(appState.vertragsoptionen) === Vertragsgrund.ERSATZGESCHAEFT &&
          immobilie.hasElementar,
      };
    }
    case GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL: {
      return {
        ...sectionState,
        versicherungsnehmerVorbelegt: true,
      };
    }
    case VwgActions.PLZ_CHANGED: {
      return {
        ...sectionState,
        adresseImmobilieVorbelegt: false,
      };
    }
    default:
      return sectionState;
  }
};
